module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-wildfly-02-m-jp.4b90d931088dfffbb7256b0269ea6899.png";